/*
 * Личный кабинет. Карточка и поля — глобальные классы base.css; здесь раскладка строк и
 * слой размытия, которого у общего диалога нет.
 */

/*
 * Размытие страницы под диалогом. z-index 39 — ровно под контейнером Modal (40): слой
 * размывает то, что нарисовано ниже него, то есть страницу, и не трогает саму карточку.
 * Префикс -webkit- нужен Safari, где свойство до сих пор только с ним.
 */
.blur {
  position: fixed;
  inset: 0;
  z-index: 39;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  pointer-events: none;
}

.meRow {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Кружок «я» крупнее строчного. Селектор составной: `.ava` живёт в base.css, который
   подключается после модулей компонентов, и при равной специфичности перебил бы размеры. */
:global(.ava).avaBig {
  width: 44px;
  height: 44px;
  font-size: 15px;
  flex: none;
}

/* min-width:0 — длинное имя обязано обрезаться, а не растягивать диалог. */
.who {
  flex: 1;
  min-width: 0;
}

.listHead {
  display: flex;
  align-items: center;
  gap: 8px;
}

.accounts {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.accRow {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px;
  border-radius: var(--r-ctl);
  min-width: 0;
}
.accRow:hover {
  background: var(--bg-alt);
}

/* Имя — кнопка выбора журнала: нажимается, значит обязано быть кнопкой, а не строкой. */
.accWho {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  background: none;
  border: none;
  padding: 0;
  font-family: var(--sans);
  text-align: left;
  cursor: pointer;
}
.accName {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink);
}

/* Выбранная строка — та, чей журнал показан ниже. Правило идёт ПОСЛЕ базового: иначе
   специфичность убывает по ходу файла и порядок применения перестаёт быть очевидным. */
.accWho[aria-pressed="true"] .accName {
  color: var(--accent-ink);
}

.form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Две колонки на широком диалоге, одна — на узком окне. */
.formGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 560px) {
  .formGrid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.log {
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-height: 240px;
  overflow-y: auto;
}

.logRow {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 5px 0;
  border-bottom: 1px solid var(--border-2);
  min-width: 0;
}
.logRow:last-child {
  border-bottom: none;
}

/* Колонка времени фиксированной ширины: без неё глаголы прыгают по строкам. */
.logTime {
  flex: none;
  width: 116px;
  font-size: 12.5px;
  color: var(--muted);
  font-variant-numeric: tabular-nums;
}

.logAct {
  flex: 1;
  min-width: 0;
  font-size: 13.5px;
  color: var(--ink-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.linkBtn {
  align-self: flex-start;
  background: none;
  border: none;
  padding: 0;
  font-family: var(--sans);
  font-size: 13px;
  color: var(--accent-ink);
  cursor: pointer;
}
.linkBtn:hover {
  color: var(--accent-ink-strong);
}

/*
 * Телефон (640): колонка времени в журнале отпускает свои 116px. Ровные штампы друг под
 * другом стоят того на широком диалоге; в карточке шириной 358px они оставляли глаголу
 * («вошёл», «сменил пароль») 200px с многоточием — то есть журнал переставал отвечать на
 * «что случилось» ради того, чтобы отвечать на «когда» столбиком.
 */
@media (max-width: 640px) {
  .logTime {
    width: auto;
    min-width: 0;
  }
}
